/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Aborted_ToastInputs */

const en_audio_description_export_aborted_toast = /** @type {(inputs: Audio_Description_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Aborted`)
};

const fr_audio_description_export_aborted_toast = /** @type {(inputs: Audio_Description_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation annulée`)
};

const de_audio_description_export_aborted_toast = /** @type {(inputs: Audio_Description_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export abgebrochen`)
};

const it_audio_description_export_aborted_toast = /** @type {(inputs: Audio_Description_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione interrotta`)
};

const ru_audio_description_export_aborted_toast = /** @type {(inputs: Audio_Description_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт прерван`)
};

const es_audio_description_export_aborted_toast = /** @type {(inputs: Audio_Description_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación abortada`)
};

const zh_cn2_audio_description_export_aborted_toast = /** @type {(inputs: Audio_Description_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出已中止`)
};

const ja_audio_description_export_aborted_toast = /** @type {(inputs: Audio_Description_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートが中止されました`)
};

const hi_audio_description_export_aborted_toast = /** @type {(inputs: Audio_Description_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात रद्द कर दिया गया`)
};

const pt_pt2_audio_description_export_aborted_toast = /** @type {(inputs: Audio_Description_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação abortada`)
};

/**
* | output |
* | --- |
* | "Export Aborted" |
*
* @param {Audio_Description_Export_Aborted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_aborted_toast = /** @type {((inputs?: Audio_Description_Export_Aborted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Aborted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_aborted_toast(inputs)
	if (locale === "de") return de_audio_description_export_aborted_toast(inputs)
	if (locale === "it") return it_audio_description_export_aborted_toast(inputs)
	if (locale === "ru") return ru_audio_description_export_aborted_toast(inputs)
	if (locale === "es") return es_audio_description_export_aborted_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_aborted_toast(inputs)
	if (locale === "ja") return ja_audio_description_export_aborted_toast(inputs)
	if (locale === "hi") return hi_audio_description_export_aborted_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_aborted_toast(inputs)
	return en_audio_description_export_aborted_toast(inputs)
});